let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bonkU")).then(() => parcelRequire('gBO8v'));